import { render, staticRenderFns } from "./CardPedido.vue?vue&type=template&id=9d50a5f8&scoped=true"
import script from "./CardPedido.vue?vue&type=script&lang=js"
export * from "./CardPedido.vue?vue&type=script&lang=js"
import style0 from "./CardPedido.vue?vue&type=style&index=0&id=9d50a5f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d50a5f8",
  null
  
)

export default component.exports